import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import ChessBoardView from '@/components/chess/ChessBoardView';
import { CheckCircle2 } from 'lucide-react';

export default function LessonView() {
  const { id } = useParams();
  const nav = useNavigate();
  const [lesson, setLesson] = useState(null);
  const [completing, setCompleting] = useState(false);

  useEffect(() => { api.get(`/lessons/${id}`).then(r => setLesson(r.data)); }, [id]);

  const complete = async () => {
    setCompleting(true);
    try {
      await api.post(`/lessons/${id}/complete`);
      toast.success('¡Lección completada! +20 puntos');
      setTimeout(() => nav(-1), 600);
    } catch (e) {
      toast.error('Error');
    } finally { setCompleting(false); }
  };

  if (!lesson) return <div className="p-8">Cargando…</div>;

  return (
    <div className="p-8 max-w-5xl mx-auto">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">Lección</div>
        <h1 className="font-display text-3xl font-extrabold" data-testid="lesson-title">{lesson.title}</h1>
      </div>
      <div className="grid lg:grid-cols-5 gap-8">
        <div className="lg:col-span-3 rounded-2xl bg-white border border-slate-200 p-6 leading-relaxed">
          <p className="text-slate-700 whitespace-pre-wrap">{lesson.content}</p>
          {lesson.video_url && (
            <div className="mt-4 aspect-video rounded-xl overflow-hidden bg-black">
              <iframe src={lesson.video_url} className="w-full h-full" allowFullScreen title="video"/>
            </div>
          )}
          <div className="mt-8">
            <Button data-testid="lesson-complete-btn" onClick={complete} disabled={completing}
              className="rounded-full bg-emerald-600 hover:bg-emerald-700 border-b-4 border-emerald-800 btn-tactile px-6 h-11 font-bold">
              <CheckCircle2 className="w-4 h-4 mr-2"/> {completing ? 'Guardando…' : 'Marcar como completada'}
            </Button>
          </div>
        </div>
        <div className="lg:col-span-2">
          {lesson.fen && <ChessBoardView fen={lesson.fen} boardWidth={380} arePiecesDraggable={false}/>}
        </div>
      </div>
    </div>
  );
}
